import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/navbar";
import Footer from "./components/footer"; 
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import NotFound from "./components/not-found";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RideTrackingScreen from "./pages/RideTrackingScreen";

//https://www.egtogo.com/?pickup=18.5204,73.8567&drop=18.5312,73.8445&rideId=ride12345&driverId=driver67890&driverName=Rahul%20Sharma&driverPhone=+91%209876543210


function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={
          <>
            <Navbar />
            <LandingPage />
            <Footer />
          </>
        } />
        <Route path="/terms-conditions" element={
          <>
            <Navbar />
            <TermsConditions />
            <Footer />
          </>
        } />
        <Route path="/privacy-policy" element={
          <>
            <Navbar />
            <PrivacyPolicy />
            <Footer />
          </>
        } />
        <Route path="/ride-tracking" element={<RideTrackingScreen />} />
        {/* <Route path="/ride-tracking/:pickup/:drop/:rideId/:driverId/:driverName/:driverPhone" element={<RideTrackingScreen />} /> */}
        <Route path="/ride-tracking/:token" element={<RideTrackingScreen />} />
        <Route path="*" element={
          <>
            <Navbar />
            <NotFound />
            <Footer />
          </>
        } />
      </Routes>
    </>
  );
}

export default App;
